import React, {useState} from 'react';
import {
   Image,
   ImageBackground,
   SafeAreaView,
   StyleSheet,
   Text,
   View,
   TextInput,
   TouchableOpacity,
} from 'react-native';
import {
   All,
   ALLCOURSE,
   appBackground,
   gray,
   HIDELEGACY,
   INSESSION,
   overAllPercent,
   primaryColor800,
   primaryColor900,
   primaryState700,
   RECENT,
   VALID,
   white,
   FONT_FAMILY_REGULAR,
} from '../../utils/utils';
import SearchView from '../dashboard/SearchView';
import TabView from '../dashboard/TabView';

const BrowsedHeaderLandsacape = props => {
   const [selectedFilter, setSelectedFilter] = useState(ALLCOURSE);
   const [selectedRecordFilter, setSelectedRecordFilter] = useState(VALID);

   return (
      <View style={styles.container}>
         <View style={styles.headerTopBackground}>
            <Image source={props.icon} style={{width: 24, height: 24}} />
            <Text
               style={{
                  flex: 1,
                  textAlignVertical: 'center',
                  color: white,
                  fontSize: 20,
                  marginLeft: 10,
                  fontWeight: '500',
                  fontFamily: FONT_FAMILY_REGULAR,
                  marginRight: 8,
               }}>
               {props.title}
            </Text>
            {props.showCourses ? (
               <Text
                  style={{
                     color: white,
                     fontSize: 10,
                     fontWeight: '600',
                     marginEnd: 16,
                     fontStyle: 'italic',
                  }}>
                  {`${props.enrolledCount} Available Courses.`}
               </Text>
            ) : null}
            {props.showSearchView ? (
               <SearchView
                  onClearText={() => {
                     props.onClearText();
                  }}
                  onSearch={text => {
                     props.onSearch(text);
                  }}
               />
            ) : null}
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {backgroundColor: primaryColor800},
   headerTopBackground: {
      backgroundColor: primaryColor800,
      paddingHorizontal: 16,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
      marginRight: 12,
   },
   headerBackground: {
      backgroundColor: '#001231',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
   },
   headerBottomBackground: {
      backgroundColor: primaryColor900,
      paddingHorizontal: 16,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
   },
   headerBottomBackground2: {
      backgroundColor: '#000000',
      paddingHorizontal: 16,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
   },
});

export default BrowsedHeaderLandsacape;
